import { GetProjectsParams } from '../../services/api/types';
import { Projects } from '../../services/api/types';

export const enum ProjectSettingsTabs {
  PROJECT_SETTINGS = 'projectSettings',
}

export type ProjectSettingsFilterSlideOverType = {
  show: boolean;
  closeModal: () => void;
  handleApplyFilters: (filters: GetProjectsParams['filters']) => void;
  filters: GetProjectsParams['filters'];
};

export type selectedProjectType = Pick<Projects, 'id' | 'name'>;
